export const operationPackageQueryKeys = {
  all: (id: string) => ['payroll-core/operation-packages', id] as const,
  list: () => ['payroll-core/operation-packages', 'list'] as const,
  countInProgress: (id: string) =>
    [...operationPackageQueryKeys.all(id), 'count-in-progress'] as const,
  patterns: (id: string) =>
    [...operationPackageQueryKeys.all(id), 'patterns'] as const,

  patternCountInProgress: (id: string, patternId: string) =>
    [
      ...operationPackageQueryKeys.all(id),
      patternId,
      'count-in-progress',
    ] as const,
  instances: (
    patternId: string,
    page: number,
    pageSize: number,
    targetId: string,
  ) =>
    [
      ...operationPackageQueryKeys.all(patternId),
      'instances',
      page,
      pageSize,
      targetId,
    ] as const,
} as const;
